import _extends from"@babel/runtime/helpers/esm/extends";import _objectWithoutProperties from"@babel/runtime/helpers/esm/objectWithoutProperties";const _excluded=["id","className","fixedWidth"];/**
 * ForkAwesomeIcon: renders a ForkAwesome icon.
 * Full list: https://forkaweso.me/Fork-Awesome/icons/
 * @module soapbox/components/fork_awesome_icon
 * @see soapbox/components/icon
 */import classNames from'classnames';import React from'react';const ForkAwesomeIcon=_ref=>{let{id,className,fixedWidth}=_ref,rest=_objectWithoutProperties(_ref,_excluded);// Use the Fork Awesome retweet icon, but change its alt
// tag. There is a common adblocker rule which hides elements with
// alt='retweet' unless the domain is twitter.com. This should
// change what screenreaders call it as well.
// const alt = (id === 'retweet') ? 'repost' : id;
return/*#__PURE__*/React.createElement("i",_extends({role:"img"// alt={alt}
,className:classNames('fa',`fa-${id}`,className,{'fa-fw':fixedWidth})},rest));};export default ForkAwesomeIcon;